/* src/app/self-enrollment/pdf/esign/esignPdf.component.css */
.title {
  text-align: center;
}
.image {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
/*# sourceMappingURL=esignPdf.component.css.map */
